module.exports = __webpack_public_path__ + "img/D15-paraguay.be1238e4.png";